module.exports = __webpack_public_path__ + "img/gb.3de413a6.svg";